import HTTP from "@/_helpers/http";
import { LOTCHART__API } from "@/_helpers/urls";
import { LOTCHART__MUTATIONS } from "../mutation-types";
import { LOTCHART__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
    chartData: [],
}

// Getters
const getters = {};

// Mutations
const mutations = {
    [LOTCHART__MUTATIONS.TRADINGLOTCHART](state, data) {
        state.chartData = data.chartData;
    },
};

// Actions
const actions = {
    async [LOTCHART__ACTIONS.TRADINGLOTCHART]({ commit }, parameter) {
        try {
            const durationParam =
                parameter?.duration != null ? `duration=${parameter.duration}` : "";

            const parameterString = [durationParam]
                .filter((param) => param !== "")
                .join("&");

            const response = await HTTP().get(
                LOTCHART__API.TRADINGLOTCHART +
                (parameterString !== "" ? `?${parameterString}` : "")
            );

            commit(LOTCHART__MUTATIONS.TRADINGLOTCHART, response.data);
        } catch (error) {
            console.log(error);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
